import React from 'react';
import classnames from 'classnames';

import { useStyles } from './connectTabs.styles';

const TABS = [
    { id: 'about', label: 'About' },
    { id: 'integrations', label: 'Integrations' },
    { id: 'pricing', label: 'Pricing' },
    { id: 'faq', label: "FAQ's" },
];

function ConnectTabs ({ active, onSelect }) {
    const classes = useStyles();

    return (
        <nav className={classes.tabs} aria-label="Connect sections">
            {TABS.map((tab) => (
                <button
                    key={tab.id}
                    type="button"
                    className={classnames(classes.tab, { [classes.tabActive]: active === tab.id })}
                    onClick={() => onSelect(tab.id)}
                >
                    {tab.label}
                </button>
            ))}
        </nav>
    );
}

export default ConnectTabs;
